

//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  

/**
  * Enum of LeadStatus values.  Keep aligned with dbo.LeadStatus
  */
enum LeadStatus {

  /**
   * 
   */
  Unknown = 0,

  /**
   * 
   */
  Unqualified = 1,

  /**
   * 
   */
  New = 2,

  /**
   * 
   */
  Working = 3,

  /**
   * 
   */
  Nurturing = 4,

  /**
   * 
   */
  Qualified = 5,

  /**
   * 
   */
  NeedsContact = 10,

  /**
   * Lead needs hipcamp follow-up
   */
  HipcampCandidateFollowUp = 13,

  /**
   * 
   */
  NeedsFollowUp = 15,

  /**
   * The ready for site visit
   */
  ReadyForSiteVisit = 16,

  /**
   * Site Visit Scheduled
   */
  SiteVisitScheduled = 17,

  /**
   * Listing in Process
   */
  ListingInProcess = 25,

  /**
   * Listing Activated
   */
  ListingActivated = 30,

  /**
   * Follow up on
   */
  FollowUpOn = 40,

  /**
   * Lead is not viable
   */
  NotViable = 50,

  /**
   * The referred to hc
   */
  ReferredToHC = 55,

  /**
   * Not Interested
   */
  NotInterested = 60,

  /**
   * Listing is ready for approval
   */
  ReadyForApproval = 118,

  /**
   * Ready for a site visit assessment
   */
  ReadyForAssessment = 116,

  /**
   * The assessment complete
   */
  AssessmentComplete = 120,

}

export default LeadStatus;